import EmrIcon from '@mui/icons-material/MedicalServices'
import { EmrCreate, EmrEdit } from './EmrCreateEdit'
import EmrList from './EmrList'

export default {
  icon: EmrIcon,
  create: EmrCreate,
  edit: EmrEdit,
  list: EmrList,
}
